import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, FlameIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Benefícios',
    href: '#beneficios'
  }, {
    name: 'Conteúdo',
    href: '#conteudo'
  }, {
    name: 'Depoimentos',
    href: '#depoimentos'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-brand-cream/95 backdrop-blur-md border-b border-brand-blush shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-139">
        <div className="flex justify-between items-center" data-id="element-140">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 group" data-id="element-141">
            <div className="bg-brand-rose/10 p-2 rounded-full group-hover:bg-brand-rose/20 transition-colors" data-id="element-142">
              <FlameIcon className="h-6 w-6 text-brand-rose" data-id="element-143" />
            </div>
            <span className="font-serif text-2xl font-bold text-brand-brown" data-id="element-144">
              JB Luz e Aroma
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-145">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-brand-brown/80 hover:text-brand-rose font-medium transition-colors text-sm uppercase tracking-wider" data-id="element-146">
                {link.name}
              </a>)}
            <motion.a href="#oferta" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="bg-brand-rose text-white px-6 py-2.5 rounded-full font-bold hover:bg-brand-rose/90 transition-colors shadow-md shadow-brand-rose/20" data-id="element-147">
              Garanta seu Ebook
            </motion.a>
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-148">
            <button onClick={() => setIsOpen(!isOpen)} className="text-brand-brown hover:text-brand-rose transition-colors p-2 bg-white/50 rounded-full backdrop-blur-sm" aria-label="Toggle menu" data-id="element-149">
              {isOpen ? <XIcon className="h-6 w-6" data-id="element-150" /> : <MenuIcon className="h-6 w-6" data-id="element-151" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-152">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-brand-cream border-b border-brand-blush overflow-hidden shadow-xl absolute w-full" data-id="element-153">
            <div className="px-4 py-6 flex flex-col space-y-4" data-id="element-154">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="text-brand-brown font-medium py-2 border-b border-brand-blush/50" data-id="element-155">
                  {link.name}
                </a>)}
              <a href="#oferta" onClick={() => setIsOpen(false)} className="w-full text-center bg-brand-rose text-white px-6 py-4 rounded-full font-bold shadow-md mt-4" data-id="element-156">
                Garanta seu Ebook Agora
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}